module.exports = __webpack_public_path__ + "media/application/images/svgs/user-plus-e701918318f3440d0a2cc2e06e23ae24.svg";